export default "__VITE_ASSET__40b4ac1e__"